import {convertSvg as Icon__small__convertSvg} from '../Icon__small/Icon__small--convert.js'

export var convert = {
  name: 'convert',
  category: 'icon',
  colorable: true,
  svg: Icon__small__convertSvg,
};
